import axios from 'axios';
import { toast } from 'react-toastify';
import CustomToast from '../../Component/CustomToast/CustomToast';

export const handleLogOut = async ({ token, setLoading, navigate }) => {
  const apiUrl = 'https://formmaker-api.altynlogistics.com/api/logout';

  if (token) {
    setLoading(true);

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);

      if (response.data.status) {
        localStorage.removeItem('authToken');
        navigate('/');
        toast(<CustomToast message="خروج با موفقیت انجام شد" state="success" />);
      } else {
        if (response.data.errors?.length > 0) {
          toast(<CustomToast message={response.data.errors[0]} state="error" />);
        }
      }
    } catch (err) {
      setLoading(false);
      console.error('Error:', err);
      toast(<CustomToast message="An error occurred. Please try again later." state="error" />);
    }
  } else {
    toast(<CustomToast message="No token found. Please log in first." state="error" />);
  }
};
